export default __webpack_public_path__ + "static/media/MutualofOmaha dark.554d3196.svg";